import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 获取用户信息
  async getUserInfo() {
    return request({
      method: GET,
      url: '/admin/asso/userInfo',
    })
  },

  // 登陆
  async login(params) {
    return request({
      method: POST,
      url: '/admin/asso/login',
      params: {
        ...params,
      },
    })
  },

  // 退出登录
  async logout() {
    return request({
      method: GET,
      url: '/admin/asso/logout',
    })
  },

  // 获取用户权限
  async getPermissionList() {
    return request({
      method: GET,
      url: '/admin/asso/getPrivilegesList',
    })
  },

  async getCert(code) {
    return request({
      method: GET,
      url: `/admin/member/selectMemberUserById/${code}`,
    })
  },

  async getCode(params) {
    return request({
      method: POST,
      url: `/admin/member/selectMemberUserByName`,
      params,
    })
  },
}
